export const isDrawioImgSource = (src: string): boolean => {
  const url = new URL(src);

  return url.pathname.toLowerCase().endsWith('.drawio');
};
